import React from "react";
import Navbar from "../components/Navbar/Navbar";
import BookShow from "./BookShowAndForm/BookShow";

export default function Home() {
  return (
    <>
      <Navbar />
      <main className="py-12 2xl:px-6">
        <BookShow />
      </main>
    </>
  );
}
